// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditDashboardModal {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing_unit_6);
}
.EditDashboardModal .EditDashboardModal-footer {
  display: flex;
  justify-content: flex-end;
  column-gap: var(--spacing_unit_4);
}`, "",{"version":3,"sources":["webpack://./src/components/DashboardModals/EditDashboardModal/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;AACE;EACE,aAAA;EACA,yBAAA;EACA,iCAAA;AACJ","sourcesContent":[".EditDashboardModal {\n  display: flex;\n  flex-direction: column;\n  row-gap: var(--spacing_unit_6);\n\n  .EditDashboardModal-footer {\n    display: flex;\n    justify-content: flex-end;\n    column-gap: var(--spacing_unit_4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
